/**
 * Labstep
 *
 * @module components/EntityImport/Action/Create/Steps/ImportFileMapping/OptionWithPreview
 * @desc Option with Preview for EntityImport Create Step 2: ImportFileMapping
 */

import type React from 'react';
import { components } from 'react-select';

export const EntityImportActionCreateStepsImportFileMappingOptionWithPreview: RFC<
  React.ComponentProps<typeof components.Option>
> = (props) => {
  if (
    props.data &&
    typeof props.data === 'object' &&
    'preview' in props.data &&
    'label' in props.data
  ) {
    return (
      <components.Option {...props}>
        <strong>{props.data.label as string}</strong>
        <br />
        {props.data.preview as React.ReactNode}
      </components.Option>
    );
  }
  return <components.Option {...props} />;
};
